import React from "react";
import { TimePicker } from "antd";

const TimeArrival = ({
  index,
  timeArrival,
  changeTimeArrivalInput,
  touched,
}) => {
  return (
    <TimePicker
    className="form-control"
      style={{
        width: "98%",
        borderRadius: "4px",
        // border:
        //   touched.flightLegs &&
        //   touched.flightLegs[index].arrivalTime &&
        //   !timeArrival[index].time &&
        //   "1px solid red",
      }}
      id={`flightLegs.return[${index}]arrivalTime`}
      name={`flightLegs.return[${index}]arrivalTime`}
      use24Hours
      value={timeArrival[index].time}
      onChange={(time, timeString) =>
        changeTimeArrivalInput(time, timeString, index)
      }
      required
    />
  );
};

export default TimeArrival;
